import MarketsPage from './MarketsPage';
import connect from './connect';

export default connect(MarketsPage);



// WEBPACK FOOTER //
// ./src/app/MarketsPage/index.js